import { Box, Layout } from '@wix/design-system'
import React, { FC, ReactNode } from 'react'

type OptionsContainerProps = {
  children?: ReactNode
}

export const OptionsContainer: FC<OptionsContainerProps> = ({ children }) => {
  return (
    <Box width="685px" direction="vertical">
      <Layout gap="SP8" rowHeight="278px">
        {children}
      </Layout>
    </Box>
  )
}
